<template>
    <div class="pageFooter">
        <div class="jobMain clearfix">
            <template v-if="!isRestrictedTestUi">
                <div class="footer-top clearfix">
                    <div class="footer-tg">
                        <div class="footer-tgt">快速导航</div>
                        <div class="footer-tgb"><a href="https://www.chinaluan.com/" target="_blank">潞安化工集团</a></div>
                        <div class="footer-tgb"><a href="https://www.luanhn.com/" target="_blank">潞安环能</a></div>
                        <div class="footer-tgb"><a href="https://www.mp12345.com" target="_blank">煤婆官网</a></div>
                        <div class="footer-tgb"><a href="https://www.mp12345.com/a.html" target="_blank">煤婆新消息APP</a></div>
                    </div>
                    <div class="footer-logo"><img src="../assets/images/footer-logo.png" alt=""/></div>
                </div>
                <div class="footer-bottom">
                    <p>本系统为潞安化工集团官方唯一指定招聘报名平台。请应聘者务必保管好个人账号信息，切勿通过非官方渠道报名，谨防受骗。</p>
                    <p>潞安化工集团有限公司 山西省长治市襄垣县侯堡镇</p>
                    <p>Copyright © 2025 潞安化工</p>
                    <p>本网站所刊登的各类信息，均为潞安化工集团版权所有，未经协议授权，禁止转载</p>
                </div>
            </template>
            <template v-else>
                <div class="footer-top clearfix footer-top--test">
                    <div class="footer-tg footer-tg--test">
                        <div class="footer-tgt">招聘测试系统</div>
                        <div class="footer-tgb">XX测试系统 · 快速导航（测试环境）</div>
                        <div class="footer-tgb footer-tgb--muted">本区域不展示正式外站链接</div>
                    </div>
                </div>
                <div class="footer-bottom footer-bottom--test">
                    <p>本系统为招聘测试系统（XX测试系统），仅供功能与流程验证使用，不作为正式招聘或报名依据。</p>
                    <p>请勿将测试账号或数据视为正式信息；正式报名请以 verify_mode=B 的正式环境为准。</p>
                    <p>Copyright © 2026 招聘测试系统</p>
                </div>
            </template>
        </div>
    </div>
</template>

<script>
export default {
    name: 'pageFooter',
    inject: {
        recruitmentUi: {
            default: () => ({ verifyMode: 'B', loaded: false }),
        },
    },
    computed: {
        isRestrictedTestUi() {
            return this.recruitmentUi && this.recruitmentUi.verifyMode === 'A'
        },
    },
}
</script>

<style scoped>
    .jobMain{width: 80%; max-width: 1500px; margin: 0 auto;}
    .pageFooter{
        background-color: #2A2C31; /* 背景颜色 */
        padding: 25px 0;
    }
    .footer-top{border-bottom: 1px solid #E60012; padding-bottom: 30px;}
    .footer-tg{width: 70%; float: left;}
    .footer-tgt{font-size: 24px; color: #D1D5DC; line-height: 48px;}
    .footer-tgb{font-size: 20px; color: #99A1AF; line-height: 48px; display: inline-block; margin-right: 20px;}
    .footer-tgb a{color: #99A1AF; text-decoration: none;}
    .footer-logo{padding-top: 20px; float: right;}
    .footer-bottom{padding-top: 20px; font-size: 12px; line-height: 20px; color: #99A1AF;}

    .footer-top--test .footer-tg--test{width: 100%; float: none;}
    .footer-tg--test .footer-tgb--muted{display: block; font-size: 14px; color: #6b7280; margin-top: 4px;}
    .footer-bottom--test p{margin: 0 0 10px 0;}

    .clearfix:after,.clearfix:before{
        clear: both;
        content: "";
        display: block;
        line-height: 0;
    }
</style>
